<!-- form panel -->
<div class="card text-dark" [ngClass]="{'mb-0':calledFromInventoryList}">
    <div class="card-header d-flex align-tems-center justify-content-between">
        <div>
            <button class="btn btn-light btn-sm" (click)="expanded = !expanded">
                @if (expanded) {
                <span class="dripicons-chevron-up"></span>
                }
                @if (!expanded) {
                <span class="dripicons-chevron-down"></span>
                }
            </button>
            {{ words[language][ 'inventorySetup' ] }}
        </div>
        @if (entityType !== 'corporation') {
        <button [disabled]="loading || form.invalid || !entityId" class="btn btn-sm btn-primary float-right"
            id="btn-save-inventorySetup" (click)="save()">{{ words[language][ 'save' ]}}</button>
        }
    </div>
    @if (expanded || calledFromInventoryList) {
    <div>
        <div class="row">
            @if (entityType !== 'corporation' || calledFromInventoryList) {
            <section class="col-md-6 col-sm-12" [ngClass]="{'col-lg-4':calledFromInventoryList}">
                <div class="card shadow-none">
                    <div class="card-header">
                        <p class="card-title">{{ words[language][ 'defaultStockFormat' ] }}</p>
                        <p class="card-subtitle text-muted">Keep in mind that once a vehicle is placed into inventory,
                            the default Stock Number format cannot be changed.</p>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="form">
                            <div class="form-group">
                                <div class="form-check">
                                    <div class="row ml-1 d-flex align-items-center">
                                        <input type="radio" id="customRadio1" value="manually" name="defaultFormat"
                                            formControlName="defaultFormat" class="form-check-input"
                                            [checked]="form.get('defaultFormat').value === 'manually'">
                                        <label class="form-check-label" for="customRadio1">Manual</label>
                                    </div>
                                </div>
                                <div class="form-check">
                                    <div class="row ml-1 d-flex align-items-center">
                                        <input type="radio" id="customRadio2" class="form-check-input"
                                            formControlName="defaultFormat" value="lastDigitsofVIN"
                                            [checked]="form.get('defaultFormat').value === 'lastDigitsofVIN'"
                                            name="defaultFormat">
                                        <label class="form-check-label" for="customRadio2"> {{ words[language][ 'last' ]
                                            }}</label>
                                        <select name="lastDigitsofVIN" id="vinNumberSelect"
                                            class="form-control form-control-sm col-3 m-1"
                                            formControlName="lastDigitsofVIN">
                                            @for (number of [6,7,8,9,10,11,12,13,14,15,16,17]; track number) {
                                            <option [value]="number">{{number}}
                                            </option>
                                            }
                                        </select>
                                        <label class="form-check-label" for="customRadio2">{{ words[language][
                                            'digitsofVIN' ] }}</label>
                                    </div>
                                </div>
                                <div class="form-check">
                                    <div class="row ml-1 d-flex align-items-center">
                                        <input type="radio" id="customRadio3" value="increment" name="defaultFormat"
                                            formControlName="defaultFormat" class="form-check-input"
                                            [checked]="form.get('defaultFormat').value === 'increment'">
                                        <label class="form-check-label" for="customRadio3">{{ words[language]['incrementBy' ]}}</label>
                                        <input type="number" class="form-control form-control-sm col-3 text-dark m-1" id="incrementBy" formControlName="incrementBy">
                                        <label class="form-check-label" for="incrementStartingAt">{{ words[language]['startingAt' ]}}</label>
                                        <input type="number" class="form-control form-control-sm col-3 text-dark m-1" id="incrementStartingAt" formControlName="incrementStartingAt">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                @if (lastUsedStockNumber) {
                                    <span>Last Used Stock Number: {{lastUsedStockNumber}}</span>
                                }
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="customCheck1" [checked]="form.get('useOriginalOnTrade').value == 'true'" formControlName="useOriginalOnTrade">
                                    <label class="form-check-label" for="customCheck1">Use Original Inventory Stock Number for Trade-in Vehicles</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="defaultStatusId">Default Status</label>
                                    <select formControlName="defaultStatusId" id="defaultStatusId"
                                        class="form-control form-control-sm text-dark">
                                        @for (status of inventoryStatuses; track status) {
                                            <option [value]="status.id">{{status.name}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="defaultCertifyLevel">Default VIN Certification Level</label>
                                    <select formControlName="defaultCertifyLevel" id="defaultCertifyLevel" class="form-control form-control-sm text-dark">
                                        @for (certifyLevel of certifyLevels; track certifyLevel.code) {
                                            <option [value]="certifyLevel.code.toLowerCase()">{{certifyLevel.code.toUpperCase()}} - {{certifyLevel.description}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            }
            @if (entityType !== 'corporation' || calledFromInventoryList) {
                <section class="col-md-6 col-sm-12" [ngClass]="{'col-lg-4':calledFromInventoryList}">
                    <div class="card shadow-none">
                        <div class="card-header">
                            <p class="card-title">{{ words[language][ 'stock' ] }} # Add-Ons</p>
                            <p class="card-title text-muted"></p>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover table-centered text-dark">
                                <thead class="p-0">
                                    <tr>
                                        <th class="border-0 p-1">{{ words[language][ 'stage' ] }}</th>
                                        <th class="border-0 p-1">{{ words[language][ 'prefix' ] }}</th>
                                        <th class="border-0 p-1">{{ words[language][ 'suffix' ] }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- inputs -->
                                    @for (stage of stages | keyvalue; track stage) {
                                        <tr>
                                            <td class="text-capitalize">{{stage.key}}</td>
                                            <td><input type="text" class="py-1 form-control form-control-sm col-12 text-dark"
                                                    [(ngModel)]="stage.value.prefix">
                                            </td>
                                            <td><input type="text" class="py-1 form-control form-control-sm col-12 text-dark"
                                                    [(ngModel)]="stage.value.suffix">
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            }
            @if (entityType === 'corporation' || calledFromInventoryList) {
            <section class="col-md-6 col-sm-12" [ngClass]="{'col-lg-4':calledFromInventoryList}">
                <div class="card shadow-none">
                    <div class="card-header">Reconditioning Type Setup</div>
                    <div class="card-body">
                        <form [formGroup]="formDesc">
                            <ng-container formArrayName="methods">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Description</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (descForm of methods.controls; track descForm; let i = $index) {
                                        <tr [formGroup]="descForm">
                                            <td id="reconTypeLabel_{{i}}">{{descForm.value.type}}</td>
                                            <td class="d-none" id="reconTypeRow_{{i}}">
                                                <select id="reconTypeSelect_{{i}}" class="form-control form-control-sm" formControlName="type">
                                                    @for (type of reconTypes; track type) {
                                                        <option [value]="type.toLowerCase()">{{type | titlecase}}</option>
                                                    }
                                                </select>
                                            </td>
                                            <td id="reconDescriptionLabel_{{i}}">{{descForm.value.description}}</td>
                                            <td class="d-none" id="reconDescriptionRow_{{i}}"><input
                                                    class="form-control form-control-sm" formControlName="description"
                                                    id="reconDescriptionInput_{{i}}"></td>
                                            <td>
                                                <button class="btn btn-info btn-sm"
                                                    (click)="editReconditioningDescriptions(i,'edit')"
                                                    id="reconEdit_{{i}}">
                                                    <span class="uil-pen"></span></button>
                                                <button class="btn btn-success btn-sm d-none"
                                                    [disabled]="descForm.invalid" (click)="saveDesc(descForm, i)"
                                                    id="reconSave_{{i}}">Save</button>
                                                <button class="btn btn-danger btn-sm d-none"
                                                    (click)="editReconditioningDescriptions(i,'cancel')"
                                                    id="reconCancel_{{i}}">
                                                    Cancel</button>
                                                <div class="btn-group dropleft">
                                                    <button class="btn btn-danger btn-sm" data-toggle="dropdown"
                                                        title="Delete" id="reconDelete_{{i}}">
                                                        <span class="uil-trash-alt"></span></button>
                                                    <div class="dropdown-menu text-center p-2">
                                                        <span class="uil-trash-alt text-danger h1"></span>
                                                        <h4 class="text-danger w-100 text-center">{{ words[language]['delete' ] }}</h4>
                                                        <span class="text-muted my-3 text-center">Are you sure you want
                                                            to delete this
                                                            Reconditioning Description? This
                                                            cannot be undone.</span>
                                                        <button class="btn btn-danger mt-2"
                                                            (click)="deleteReconDesc(descForm.value.id)"
                                                            [disabled]="loading">
                                                            @if (loading) {
                                                            <span class="spinner-grow spinner-grow-sm mr-1"
                                                                role="status"></span>
                                                            }
                                                            {{ words[language][ 'continue' ] }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        }
                                        <tr>
                                            <button type="button" class="btn btn-success btn-sm" (click)="add(null)"
                                                id="addMethod"><span class="dripicons-plus"></span>
                                                {{words[language].addAnother}}</button>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>
                        </form>
                    </div>
                </div>
            </section>
            }
        </div>
    </div>
    }
</div>

<!-- ! delete modal -->
<!-- <div class="modal fade" id="deleteDescriptionModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
<div class="modal-dialog modal-sm modal-dialog-centered">
<div class="modal-content">
<div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
<span class="dripicons-cross text-danger h1"></span>
<h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
<span class="text-muted my-3 text-center">Are you sure you want to delete this Reconditioning Description? This
cannot be undone.</span>
<button class="btn btn-danger mt-2" (click)="deleteReconDesc()" [disabled]="loading">
<span class="spinner-grow spinner-grow-sm mr-1" role="status" *ngIf="loading"></span>
{{ words[language][ 'continue' ] }}
</button>
<button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
id="close-delete-modal-description">{{ words[language][ 'cancel' ]
}}</button>
</div> -->
<!-- </div>/.modal-content -->
<!-- </div>/.modal-dialog -->
<!-- </div>/.modal -->